import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// CDK
import { LayoutModule } from '@angular/cdk/layout';

// MATERIAL 17 (MDC, no legacy)
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatStepperModule } from '@angular/material/stepper';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';

//Custom Date
import { CustomDateAdapter, MY_NATIVE_FORMATS } from './custom-date-adapter/custom-date-adapter';

// FIREBASE
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';

// NG-BOOTSTRAP
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// SHARED
import { SharedModule } from './shared';

// HELPERS / INTERCEPTORES
import { SessionInterceptor } from '@app/helpers/session.interceptor';
import { LoaderInterceptorService } from '@app/helpers/loader-interceptor.service';
import { Crypt } from './helpers/crypt';

import { environment } from '../environments/environment';

// COMPONENTES
import { FilesByDepartamentsComponent } from './admin/files-by-departaments/files-by-departments/files-by-departments.component';
import { ExternalResReqComponent } from './admin/external-responses-requests/external-res-req/external-res-req.component';
import { UploadPersonBlockedComponent } from './admin/compliance/upload-person-blocked/upload-person-blocked.component';
import { UploadPreapprovalsComponent } from './admin/upload-preapprovals/upload-preapprovals.component';
import { SendCampaignsComponent } from './admin/send-campaigns/send-campaigns.component';
import { ExecuteQueryComponent } from './admin/execute-query/execute-query.component';
import { BinnacleComponent } from './admin/binnacle/binnacle.component';
import { GeneratePreapprovalsMrpComponent } from './admin/generate-preapprovals-mrp/generate-preapprovals-mrp.component';
import { FactoringRequestsComponent } from './admin/factoring-requests/factoring-requests.component';
import { UploadFilesSfIframeComponent } from './admin/upload-files-sf-iframe/upload-files-sf-iframe.component';
import { ProtectedActionsComponent } from './admin/protected-actions/protected-actions.component';

@NgModule({ declarations: [
        AppComponent,
        FilesByDepartamentsComponent,
        ExternalResReqComponent,
        UploadPersonBlockedComponent,
        UploadPreapprovalsComponent,
        SendCampaignsComponent,
        ExecuteQueryComponent,
        BinnacleComponent,
        GeneratePreapprovalsMrpComponent,
        FactoringRequestsComponent,
        UploadFilesSfIframeComponent,
        ProtectedActionsComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        LayoutModule,
        /** Shared / terceros */
        SharedModule,
        NgbModule,
        /** Material 17 (MDC) */
        MatSidenavModule,
        MatListModule,
        MatSelectModule,
        MatDatepickerModule,
        MatStepperModule,
        /** Firebase */
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFireStorageModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true },
        Crypt,
        provideHttpClient(withInterceptorsFromDi()),
        { provide: MAT_DATE_LOCALE, useValue: 'es-MX' },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MY_NATIVE_FORMATS },
        ] })
export class AppModule { }
